/** @format */

import { env } from '../env';

const config = {
  googleAppScriptEmailURL: env.REACT_APP_GOOGLE_APP_SCRIPT_EMAIL_URL
};

export default config;
